import { localStorage } from "@web-monorepo/safe-browser-storage";

/** Written by the dev tools "Use precanary" toggle; persists across reloads, unlike the window globals. */
export const USE_PRECANARY_STORAGE_KEY = "devTools.usePrecanary";

// The toggle writes via useLocalStorage<boolean>, so the stored value is JSON: "true" or "false".
export function isPrecanaryRequested(): boolean {
  return (
    Boolean(global.usePrecanary ?? global.usePreCanary) || localStorage.getItem(USE_PRECANARY_STORAGE_KEY) === "true"
  );
}
